import type { ChangelogFormatter } from '../../types';
import createPrettifiedBuffer from './prettifiedBuffer';
import createTemplates from '../templates';
import Components from './components';
import format from '../textBasedFormatter';


const prettifiedFormatter: ChangelogFormatter<React.ReactNode> = ({
  A,
  B,
  changesByActionPublicId,
  featureFlags,
}) => {
  const prettifiedBuffer = createPrettifiedBuffer();
  const templates = createTemplates({ atoms: Components, featureFlags });

  return format({
    A,
    B,
    changes: Object.values(changesByActionPublicId).flat(),
    processingBuffer: prettifiedBuffer,
    templates,
  });
};


export default prettifiedFormatter;
